export function normalizeQuantityValue(value) {
  if (value === null || value === undefined || value === '') {
    return 0;
  }

  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : 0;
}

export function normalizeBomCountValue(value) {
  const numericValue = normalizeQuantityValue(value);
  return Number.isFinite(numericValue) ? Math.round(numericValue) : 0;
}

export function formatQuantityValue(value) {
  const numericValue = normalizeQuantityValue(value);
  return Number.isFinite(numericValue) ? numericValue.toFixed(3) : '0.000';
}

export function normalizeQuantityRows(rows = []) {
  return rows.map((row) => ({
    ...row,
    quantity: normalizeQuantityValue(row?.quantity),
  }));
}
